<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu  :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="list">发票类型</el-menu-item>
		  <el-menu-item index="list2">开票明细</el-menu-item>
		  <el-menu-item index="list3">有花果收款账户</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
			<dSeal v-if="activeIndex == 'list'" ></dSeal>
			<ySeal v-else-if="activeIndex == 'list2'"></ySeal>
			<yVoid v-else-if="activeIndex == 'list3'"></yVoid>
      </div>
    </div>
  </div>
</template>

<script>
import dSeal from './dSeal.vue';//发票类型
import ySeal from './ySeal.vue';//开票明细
import yVoid from './yVoid.vue';//有花果收款账户
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeIndex: "list",
      queryData: {},
	  restId:null,
    };
  },
  components: {
	dSeal,
	ySeal,
	yVoid,
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
    handleSelect(key, keyPath){
	  console.log(key, keyPath)
      this.activeIndex = key;
    },
    dealToContractList() {
      this.activeIndex = "list";
    },
  },
};
</script>